import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DropdownResults.css';
import React from "react";
import { ReactComponent as IconChevronDown } from '../../../../../resources/icons/IconChevronDown.svg';
export var DropdownResults = function DropdownResults(_ref) {
  var filteredOptions = _ref.filteredOptions,
    label = _ref.label,
    _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-12' : _ref$columnsClass,
    handleAnalitics = _ref.handleAnalitics;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setisOpen = _React$useState2[1];
  var drop = React.useRef();
  var borderRadius = {
    borderRadius: '4px'
  };
  function handleClick(e) {
    if (e.target.closest('.filter__field') !== drop.current && !e.target.closest('.filter-panel__mob-label')) {
      setisOpen(false);
    }
  }
  var toggleFilter = function toggleFilter(e) {
    setisOpen(!isOpen);
    if (isOpen) {
      document.body.removeEventListener('click', handleClick);
    } else {
      document.body.addEventListener('click', handleClick);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(columnsClass, " ").concat(customClass, " ").concat(customClass == 'brightcoveHeader__dropdown' ? brightcoveStyles : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field  dropdown-result",
    ref: drop
  }, /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    onClick: toggleFilter,
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : ''),
    onKeyPress: function onKeyPress(event) {
      if (event.which === 13 || event.which === 32) {
        event.preventDefault();
        setisOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : ''),
    style: !isOpen ? borderRadius : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "filter-panel__inner--items"
  }, filteredOptions.map(function (item, index) {
    var title = item.title,
      url = item.url,
      name = item.name;
    return /*#__PURE__*/React.createElement("li", {
      onClick: function onClick() {
        if (handleAnalitics) {
          handleAnalitics(name);
        }
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      tabIndex: 0,
      "aria-label": title,
      "aria-labelledby": title,
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, title));
  })))))));
};
var commonStyles = "cssrs8l";
var brightcoveStyles = "brilzib";